import '@stimulus/polyfills'
import zenscroll from './zenscroll';
import { definitionsFromContext } from "stimulus/webpack-helpers"
import 'sharer.js'
import 'intersection-observer'

zenscroll.setup(500, 35)

function load() {
    if (window.app) {
        const context = require.context("./controllers", true, /\.js$/)
        app.load(definitionsFromContext(context))
    } else {
        setTimeout(load, 5);
    }
}

load()
